import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

const host = window.location.hostname.toLowerCase();

// domínio raiz (apex): gopass.mobi ou www.gopass.mobi
const isApex = host === "gopass.mobi" || host === "www.gopass.mobi";

// no apex você pode querer servir /sucesso; em QUALQUER subdomínio o base é "/"
const basename = isApex ? "/sucesso" : "/";

console.log("[Router] basename =", basename, "| host =", host);

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { hasError: boolean }> {
  constructor(props:any){ super(props); this.state = { hasError: false }; }
  static getDerivedStateFromError(){ return { hasError: true }; }
  componentDidCatch(err:any, info:any){ console.error("Render error:", err, info); }
  render(){ return this.state.hasError ? <div style={{padding:24,fontFamily:"sans-serif"}}>Algo deu errado ao renderizar.</div> : this.props.children as any; }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
